import { useEffect } from 'react'

/**
 * A screen left on — a branch's clock screen on the wall, a portable screen at the counter — should not go dark: holds
 * a wake lock while the page shows (asked again when it comes back)
 */
export function useWakeLock() {
  useEffect(() => {
    let lock: { release: () => Promise<void> } | null = null
    const nav = navigator as Navigator & { wakeLock?: { request: (type: 'screen') => Promise<{ release: () => Promise<void> }> } }
    const hold = async () => {
      if (document.visibilityState !== 'visible' || !nav.wakeLock) return
      lock = await nav.wakeLock.request('screen').catch(() => null)
    }
    hold()
    document.addEventListener('visibilitychange', hold)
    return () => {
      document.removeEventListener('visibilitychange', hold)
      lock?.release().catch(() => {})
    }
  }, [])
}
